// extracted by css-extract-rspack-plugin
export default {"NewRulesetButtonContainer":"NewRulesetButton-module__NewRulesetButtonContainer__Ulk0N","NewRulesetButtonMenuItemBox":"NewRulesetButton-module__NewRulesetButtonMenuItemBox__A8iBR"};